module.exports = __webpack_public_path__ + "media/Loops 110 Keys.d20f920c.wav";